import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MessageSquare } from 'lucide-react';
import { useSubscription } from '../../modules/subscription/application/useSubscription';
import { useBreakpoint } from '../../hooks/useBreakpoint';
import { LAYOUT } from '../layout';
import AlchelyChatModal from './AlchelyChatModal';

export default function AlchelyChatFAB() {
  const { t } = useTranslation();
  const { isPremium } = useSubscription();
  const { isMobile, isTablet } = useBreakpoint();
  const [isOpen, setIsOpen] = useState(false);

  if (!isPremium) return null;

  const isSmallScreen = isMobile || isTablet;
  const bottomOffset = isSmallScreen
    ? `calc(${LAYOUT.NAV_HEIGHT.BOTTOM_BAR} + 16px)`
    : '24px';
  const rightOffset = isSmallScreen ? '16px' : '24px';

  return (
    <>
      <button
        aria-label={t('alchelyChat.openButton')}
        aria-expanded={isOpen}
        onClick={() => setIsOpen(true)}
        style={{ bottom: bottomOffset, right: rightOffset }}
        className="fixed z-60 flex items-center justify-center w-14 h-14 rounded-full bg-brand-500 hover:bg-brand-600 text-white shadow-lg transition-colors"
      >
        <MessageSquare className="w-6 h-6" />
      </button>

      {isOpen && <AlchelyChatModal onClose={() => setIsOpen(false)} />}
    </>
  );
}
